// extracted by mini-css-extract-plugin
export default {"form-control":"WeeklyForm_form-control__RUXsB"};